import { createAsyncThunk } from '@reduxjs/toolkit'
import { IUser } from '../../../../entities/User'
import { AUTH_USER_LS_KEY } from '../../../../entities/AuthUser/model/constants/constants'
import { authUserActions } from '../../../../entities/AuthUser'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { loginActions } from '../slices/loginSlice'
import {
	mapRightsNullToNoPermission
} from '../../../../shared/lib/mappers/mapRightsNullToNoPermission'
import { mapCSuite } from '../../../../shared/lib/mappers/mapCSuite'
import { MfaError } from '../types/mfaErrors'

export interface LoginMFAProps {
	challengeId: string
	otpCode: string
}

export const loginMFA = createAsyncThunk<
	IUser,
	LoginMFAProps,
	ThunkConfig<{ message: string | undefined, errorStatus?: MfaError }>
>('login/loginMFA', async ({ challengeId, otpCode }, thunkAPI) => {

	const { dispatch, extra: { api }, rejectWithValue } = thunkAPI

	try {
		const { data: user } = await api.post<IUser>('/mfa/verify', {
			challengeId,
			otp: otpCode
		})

		const authUser = mapRightsNullToNoPermission(user)
		mapCSuite(authUser)
		localStorage.setItem(AUTH_USER_LS_KEY, JSON.stringify(authUser))

		dispatch(authUserActions.setAuthData(authUser))
		dispatch(loginActions.resetLoginState())

		return authUser
	} catch (e: any) {
		console.log(e)
		const message = (e.response?.data?.message || e.message) as string | undefined
		const errorStatus = (e.response?.data?.errorStatus) as MfaError | undefined
		return rejectWithValue({ message, errorStatus })
	}
})
